const styles = (theme) => ({
  underline: {
    '&:before': {
      borderColor: theme.color.grey_medium,
    },
    '&:hover:not(.Mui-disabled):before': {
      borderColor: theme.color.grey_medium,
    },
  },
  searchIcon: {
    margin: theme.spacing(1, 2, 1, 0),
    height: 20,
    '& path': {
      fill: theme.color.black,
    },
  },
  clearButton: {
    padding: theme.spacing(1),
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '& svg': {
      height: 20,
      width: 20,
      fill: theme.color.grey_dark,
    },
  },
  endIcon: {
    marginLeft: theme.spacing(1),
  },
});

export default styles;
